<template>
  <div>
    <div v-for="item in tableList" :key="item.title">
      <div :class="['year', item.left ? 'left' : '']">{{item.header}}</div>
      <div class="last-year" v-if="!item.end">
        <div
          @click="click(childrenItem)"
          class="month"
          v-for="childrenItem in item.children"
          :key="childrenItem.title"
        >
          {{ childrenItem.title }}
        </div>
      </div>
        <div class="last-year" v-else>
        <div
          @click="click({id: item.header, title: childrenItem + '月', index: childrenItem})"
          class="month"
          v-for="childrenItem in Number(item.end)"
          :key="childrenItem"
        >
          {{ childrenItem + '月'}}
        </div>
      </div>
      </div>
  </div>
</template>
<script>
export default {
  props: {
    tableList: {
      type: Array,
      default: () => []
    },
    click: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {}
  }
}
</script>
<style scoped lang="less">
.year{
  text-align: center;
  color: rgba(122, 134, 153, 1);
  font-size: 30px;
  margin: 46px 0px 24px;
  font-weight: bold;
}
.none{
  opacity: 0;
}
.position{
  top: 50%;
  position: fixed;
  width: 100%;
  height: 112px;
  background: rgba(245, 244, 244, 1);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}
.top{
  height: 100%;
  align-items: center;
  display: flex;
  position: relative;
  div:first-of-type{
    width: 40px;
    height: 40px;
  }
  div:last-of-type{
    flex-grow: 1;
    text-align: center;
    font-size: 30px;
    color: rgba(31, 36, 51, 1);
    font-weight: bold;
  }
  border-bottom: 1Px solid rgba(227, 228, 230, 1);
}
.close{
  position: absolute;
  top: 20px;
  left: 28px;
}
.content{
  padding: 8px 28px 0px;
  font-size: 30px;
  box-sizing: border-box;
  margin-top: 112px;
  .last-year,.this-year{
    display: grid;
    grid-gap: 10px;
    grid-template-columns: repeat(4, 1fr);
  }
  .month{
    color: rgba(31, 36, 51, 1);
    font-family: 'Alibaba PuHuiTi';
    font-weight: bold;
    margin-bottom: 18px;
    background: #fff;
    width: 160px;
    height: 108px;
    text-align: center;
    line-height: 108px;
    border-radius: 4px;
  }
}
.left{
  text-align: left !important;
}
</style>
